export default __webpack_public_path__ + "static/media/gm.dfd25b88.svg";